import CommonHeader from '../Components/Headers/CommonHeader';
import Biomarkers from '../Components/Biomarkers/Biomarkers';

export default function BiomarkersPage() {
  return (
    <>
      <CommonHeader />
      <Biomarkers />
    </>
  );
}
